
$(document).ready(function () {
  if ($.fn.slick) {
    $(".home-main-slider-wrap").slick({
      arrows: false,
      dots: true,
    });
    $(".home-categories-slider-wrap").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: false,
      dots: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
    $(".home-brands-slider-wrap").slick({
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 6,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });
    if ($(".product-slider .product-slide").length > 1) {
    $(".product-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      fade: true,
      asNavFor: ".product-thumbnail-slider",
    });
    $(".product-thumbnail-slider").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      vertical: true,
      asNavFor: ".product-slider",
      focusOnSelect: true,
      arrows: false,
    });
    }
  }
  $(".header-navigation-toggle-btn").on("click", function () {
    var navigation = $(".header-navigation");
    navigation.toggleClass("active");
    $(this).attr("aria-expanded", navigation.hasClass("active") ? "true" : "false");
  });
  $(document).on("keydown", function (event) {
    if (event.key === "Escape" && $(".header-navigation").hasClass("active")) {
      $(".header-navigation").removeClass("active");
      $(".header-navigation-toggle-btn").attr("aria-expanded", "false").trigger("focus");
    }
  });
  $(".product-quantity-input").on("keypress keyup blur", function (e) {
    $(this).val(
      $(this)
        .val()
        .replace(/[^\d].+/, "")
    );
    if (e.which < 48 || e.which > 57) {
      e.preventDefault();
    }
  });
  $(".product-quantity-plus").click(function () {
    var currentValue = $(".product-quantity-input").val();
    currentValue = parseInt(currentValue) + 1;
    $(".product-quantity-input").val(currentValue);
  });
  $(".product-quantity-minus").click(function () {
    var currentValue = $(".product-quantity-input").val();
    if (currentValue > 1) {
      currentValue = parseInt(currentValue) - 1;
      $(".product-quantity-input").val(currentValue);
    }
  });
  $(".product-listing-filter-toggle-btn").on("click", function () {
    $(".product-listing-filter-all").addClass("active");
    return false;
  });
  $("html").on("click", function () {
    $(".product-listing-filter-all").removeClass("active");
  });
  $(".product-listing-filter-all").on("click", function (e) {
    e.stopPropagation();
  });
   if ($.fn.zoom && $(window).width() > 768) {
    $(".product-slide").zoom();
  }
});



// match height

// $(function ($) {  
// $(window).on('load',function() {
// equalheight('.product-sm-image');
// equalheight('.home-categories-slide-image');
// equalheight('.product-sm-content h6');  

// });
 
// $(window).on('resize',function() {
// equalheight('.product-sm-image');
// equalheight('.home-categories-slide-image');
// equalheight('.product-sm-content h6');  
// });  
  
// });

